export default {
  getAllBanner: {},
  selectedBanner: {},
};
